import _ from "lodash";
import React, { useState } from "react";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";

import classes from "./CourseSelection.scss";
import CurriculumList from "./CurriculumList";
import CourseSelectionPage from "./CourseSelectionPage";
import {
  getPlannerElementSetsGroupedByType,
  setCurrentPlannerElementSets,
} from "Platform/modules/PlatformModule";
import { getOrganizationCurriculumPrograms } from "modules/CommonSelectors";
import { CURRICULUM_TYPE_PYP } from "Constants/stringConstants";

const CourseSelection = ({
  selectedIds,
  handleSelect,
  fetchTemplates = false,
  organizationCurriculumPrograms,
  setCurrentPlannerElementSets,
  selectedGlobalGradeUid,
  shouldCheckIfTermsExist = false,
  defaultCurriculum,
  isCurriculumSelectionEnabled = true,
  shouldDisplaySubjects,
  academicYears = [],
  courseSubjectType,
  shouldSetPlatformCurriculumOnMount = true,
}) => {
  const [selectedCurriulum, setSelectedCurriculum] = useState(
    defaultCurriculum
  );
  const [selectedGradeId, setSelectedGradeId] = useState(null);
  const [selectedSubjectId, setSelectedSubjectId] = useState("all");
  const [loadingCurriculums, setLoadingCurriculums] = useState(true);

  const onCurriculumChange = curriulumProgram => {
    setSelectedCurriculum(curriulumProgram);

    const isSameCurriculumClicked =
      _.get(curriulumProgram, "id", "") === _.get(selectedCurriulum, "id", "");

    if (isSameCurriculumClicked) return;
    setSelectedGradeId(null);
    setSelectedSubjectId(null);
  };

  const onCourseSelection = ({ course }) => {
    const currentCourseId = _.get(selectedIds, "0", "");
    const newCourseId = _.get(course, "id", "");
    if (currentCourseId === newCourseId) return;

    // setup planner element sets
    const plannerElementSets = getPlannerElementSetsGroupedByType({
      organizationCurriculumPrograms,
      curriculumProgramId: selectedCurriulum?.id,
    });
    setCurrentPlannerElementSets(plannerElementSets);

    handleSelect({
      courseId: newCourseId,
      curriculumProgram: selectedCurriulum,
      course,
    });
  };

  return (
    <div className={classes.container}>
      {isCurriculumSelectionEnabled ? (
        <CurriculumList
          selectedCurriulum={selectedCurriulum}
          onCurriculumChange={onCurriculumChange}
          academicYears={academicYears}
          shouldSetPlatformCurriculumOnMount={
            shouldSetPlatformCurriculumOnMount
          }
          curriculumsLoaded={() => setLoadingCurriculums(false)}
        />
      ) : null}
      <div className={classes.courseSelectionContainer}>
        <CourseSelectionPage
          selectedCurriulum={selectedCurriulum}
          selectedIds={selectedIds}
          handleSelect={onCourseSelection}
          fetchTemplates={fetchTemplates}
          selectedGradeId={selectedGradeId}
          selectedGlobalGradeUid={selectedGlobalGradeUid}
          onChangeGradeId={gradeId => setSelectedGradeId(gradeId)}
          selectedSubjectId={selectedSubjectId}
          onChangeSubjectId={subjectId => setSelectedSubjectId(subjectId)}
          shouldCheckIfTermsExist={shouldCheckIfTermsExist}
          shouldDisplaySubjects={shouldDisplaySubjects}
          academicYears={academicYears}
          courseSubjectType={courseSubjectType}
          loadingCurriculums={loadingCurriculums}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const {
    isCurriculumSelectionEnabled = true,
    shouldDisplaySubjects: _shouldDisplaySubjects,
  } = ownProps;
  const currentCurriculumProgramId = _.get(
    state,
    "platform.currentCurriculumProgram.id",
    ""
  );

  const currentCurriculumProgramType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    ""
  );

  // PYP courses are not mapped with subjects
  const shouldDisplaySubjects =
    _shouldDisplaySubjects &&
    currentCurriculumProgramType !== CURRICULUM_TYPE_PYP;

  const organizationCurriculumPrograms = getOrganizationCurriculumPrograms(
    state
  );

  const defaultCurriculum = !isCurriculumSelectionEnabled
    ? _.find(organizationCurriculumPrograms, {
        id: currentCurriculumProgramId,
      })
    : null;

  return {
    organizationCurriculumPrograms: organizationCurriculumPrograms,
    defaultCurriculum,
    shouldDisplaySubjects,
  };
};

const mapActionCreators = {
  setCurrentPlannerElementSets,
};

export default compose(connect(mapStateToProps, mapActionCreators))(
  CourseSelection
);
